module.exports = __webpack_public_path__ + "a51182ff75a6cc5ca24bf31b74f23b9b.svg";